import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import * as _ from 'lodash'
import { CustomHttpUrlEncodingCodec } from '@app/_helpers';


@Injectable({
    providedIn: 'root'
})
export class CategoryPageService {
    constructor(private http: HttpClient) { }
    public categoriesSubject$: BehaviorSubject<any> = new BehaviorSubject(null);
    readonly categories$: Observable<any[]> = this.categoriesSubject$.asObservable();
    public colorsSubject$: BehaviorSubject<any> = new BehaviorSubject(null);
    readonly categoryColors$: Observable<any> = this.colorsSubject$.asObservable();
    public hasProfessionalsSubject$: BehaviorSubject<any> = new BehaviorSubject(false);
    readonly hasProfessionals$: Observable<any> = this.hasProfessionalsSubject$.asObservable();

    getCategory(id): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/homepage/category/${id}`).pipe(
            tap(response => {
                this.categoriesSubject$.next(response.categories ?? []);
                this.colorsSubject$.next(response.colors ?? {});
                this.hasProfessionalsSubject$.next(response.hasProfessionals ?? false);
            })
        );
    }

    get categories() {
        return this.categoriesSubject$.value;
    }

    get categoryColors() {
        return this.colorsSubject$.value;
    }
    getCategories(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/categories`);
    }

    getMainCategory(categorySlug): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/categories/main-category`, { params: categorySlug });
    }


    getSubCategories(categoryId: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/categories?categoryId=${categoryId}`);
    }

    getProducts(slug, params?): Observable<any> {
        let filterParams: HttpParams = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec()
        });
        if (params) {
            _.forEach(params, (value, key) => {
                filterParams = filterParams.append(key, value)
            });
        }
        return this.http.get<any>(`${environment.apiUrl}/products/category/${slug}`, { params: filterParams });
    }

    getProductsOnly(params?): Observable<any> {
        let filterParams: HttpParams = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec()
        });
        if (params) {
            _.forEach(params, (value, key) => {
                filterParams = filterParams.append(key, value)
            });
        }
        return this.http.get<any>(`${environment.apiUrl}/products`, { params: filterParams });
    }
}
